const PARTNERS = [
  { name: "Genetec", status: "Integration in development" },
  { name: "Axis", status: "Axis TIPP member" },
  { name: "Procore", status: "Coming soon" },
];

export const Partners = () => {
  return (
    <section id="partners" data-testid="partners-section" className="bg-slate-50 py-16 md:py-20">
      <div className="mx-auto max-w-6xl px-6 md:px-10">
        <p className="text-center text-xs font-semibold uppercase tracking-widest text-slate-500">
          Partners
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-8 md:gap-12">
          {PARTNERS.map((partner) => (
            <div
              key={partner.name}
              data-testid={`partner-${partner.name.toLowerCase()}`}
              className="text-center"
            >
              <p className="text-lg font-semibold text-navy">{partner.name}</p>
              <p className="mt-1 text-sm text-slate-500">{partner.status}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
